const softHyphen = '\u00AD';
export function hyphenAsSoftHyphen(input: string) {
    return input.replace(/-/gi, softHyphen);
}
